import { displayFontFamily } from "styles/theme";

const INK = "#0E3A2A";
const INK_MUTED = "#6B7770";
const HAIRLINE = "#E5DCC8";
const HAIRLINE_STRONG = "#D8CCB2";
const CREAM = "#F9F8F7";
const MINT = "#D6EFE0";
const MINT_INK = "#1F6B49";

const styles = {
  drawerPaper: {
    width: { xs: "100%", sm: 480 },
    maxWidth: "100%",
    backgroundColor: CREAM,
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    gap: "14px",
    p: "22px 24px",
    borderBottom: `1px solid ${HAIRLINE}`,
  },
  headerIcon: {
    width: 44,
    height: 44,
    borderRadius: "12px",
    display: "grid",
    placeItems: "center",
    backgroundColor: MINT,
    color: MINT_INK,
    flexShrink: 0,
  },
  headerText: {
    flex: 1,
  },
  headerTitle: {
    fontFamily: displayFontFamily,
    fontWeight: 600,
    fontSize: 24,
    letterSpacing: "-0.5px",
    color: INK,
    lineHeight: 1.1,
  },
  headerSubtitle: {
    color: INK_MUTED,
    fontSize: 13.5,
    mt: "4px",
  },
  closeButton: {
    color: INK_MUTED,
    p: "4px",
    "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
  },
  body: {
    flex: 1,
    overflowY: "auto",
    p: "20px 24px",
  },
  sectionHead: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  sectionTitle: {
    fontFamily: displayFontFamily,
    fontWeight: 600,
    fontSize: 22,
    letterSpacing: "-0.4px",
    color: INK,
  },
  sectionSubtitle: {
    color: INK_MUTED,
    fontSize: 13,
    mt: "2px",
    mb: "14px",
  },
  searchBox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "white",
    border: `1px solid ${HAIRLINE}`,
    borderRadius: "14px",
    px: "14px",
    height: 48,
    mb: "16px",
    color: INK_MUTED,
  },
  searchInput: {
    flex: 1,
    fontSize: 14,
    color: INK,
    "& input": { padding: 0 },
    "& input::placeholder": { color: INK_MUTED, opacity: 1 },
  },
  searchClear: {
    color: INK_MUTED,
    p: "4px",
    "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
  },
  categoryCard: {
    backgroundColor: "white",
    border: `1px solid ${HAIRLINE}`,
    borderRadius: "16px",
    mb: "10px",
    overflow: "hidden",
  },
  categoryCardActive: {
    backgroundColor: "#F4FBF6",
    border: `1px solid ${MINT}`,
    borderRadius: "16px",
    mb: "10px",
    overflow: "hidden",
  },
  categoryRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    p: "16px 18px",
    cursor: "pointer",
  },
  checkbox: (state: "none" | "some" | "all") => ({
    width: 22,
    height: 22,
    borderRadius: "7px",
    flexShrink: 0,
    display: "grid",
    placeItems: "center",
    border: state === "none" ? `2px solid ${HAIRLINE_STRONG}` : "none",
    backgroundColor: state === "none" ? "transparent" : INK,
    color: "white",
    cursor: "pointer",
  }),
  categoryName: {
    flex: 1,
    fontSize: 15,
    fontWeight: 700,
    color: INK,
  },
  countBadge: {
    backgroundColor: MINT,
    color: MINT_INK,
    fontSize: 12,
    fontWeight: 700,
    borderRadius: "999px",
    px: "10px",
    py: "3px",
  },
  chevron: {
    color: INK_MUTED,
    display: "flex",
  },
  chipArea: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    p: "0 18px 18px",
  },
  chip: (selected: boolean) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    px: "14px",
    py: "8px",
    borderRadius: "999px",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    border: selected ? `1px solid ${MINT_INK}` : `1px solid ${HAIRLINE}`,
    backgroundColor: selected ? MINT : "white",
    color: selected ? MINT_INK : INK,
    "&:hover": { borderColor: selected ? MINT_INK : HAIRLINE_STRONG },
  }),
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    p: "16px 24px",
    borderTop: `1px solid ${HAIRLINE}`,
    backgroundColor: CREAM,
  },
  footerCount: {
    fontFamily: displayFontFamily,
    fontSize: 15,
    fontWeight: 600,
    color: INK,
  },
  footerActions: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  cancelButton: {
    color: INK,
    fontSize: 14,
    fontWeight: 600,
    textTransform: "none",
    "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
  },
  saveButton: {
    backgroundColor: INK,
    color: "white",
    borderRadius: "999px",
    px: "22px",
    py: "11px",
    fontSize: 14,
    fontWeight: 600,
    textTransform: "none",
    "&:hover": { backgroundColor: "#07271c" },
    "&.Mui-disabled": { backgroundColor: HAIRLINE_STRONG, color: "white" },
  },
  emptyState: {
    color: INK_MUTED,
    fontSize: 14,
    textAlign: "center",
    py: "28px",
  },
};

export default styles;
